export default {
  fa: {
    title: 'مدیریت دعوت‌نامه‌ها',
    newInvitation: 'دعوت‌نامه جدید',
    loadError: 'خطا در بارگذاری دعوت‌نامه‌ها',
    createdNoPhone: 'دعوت‌نامه ایجاد شد — لینک را دستی ارسال کنید',
    createdSmsSent: 'دعوت‌نامه ایجاد و پیامک ارسال شد!',
    createdSmsFailed: 'دعوت‌نامه ایجاد شد ولی ارسال پیامک ناموفق بود',
    createError: 'خطا در ایجاد دعوت‌نامه',
    resendSmsError: 'خطا در ارسال مجدد پیامک',
    linkCopied: 'لینک دعوت‌نامه کپی شد',
    editSuccess: 'دعوت‌نامه ویرایش شد',
    editError: 'خطا در ویرایش دعوت‌نامه',
    toggleError: 'خطا در تغییر وضعیت دعوت‌نامه',
    deleteSuccess: 'دعوت‌نامه حذف شد',
    deleteError: 'خطا در حذف دعوت‌نامه',
    nameColumn: 'نام',
    phoneColumn: 'شماره تماس',
    codeColumn: 'کد دعوت',
    ticketCodeColumn: 'کد بلیت',
    entrySourceColumn: 'منبع ورود',
    entrySourceDirect: 'دعوت مستقیم',
    entrySourceWaitlist: 'از لیست انتظار',
    trainDepartureColumn: 'حرکت قطار',
    setTime: 'تعیین زمان',
    linkColumn: 'لینک',
    copyLink: 'کپی لینک',
    statusColumn: 'وضعیت',
    statusUsed: '✅ استفاده شده',
    statusWaiting: '⏳ منتظر',
    viewColumn: 'بازدید لینک',
    notOpened: 'باز نشده',
    viewedTimes: '{{first}} ({{count}} بار)',
    firstViewedTooltip: 'اولین بازدید: {{first}}',
    lastViewedSuffix: ' — آخرین بازدید: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ ارسال شده',
    smsPending: '⏳ منتظر',
    smsFailed: '❌ ناموفق',
    resend: 'ارسال مجدد',
    activeColumn: 'فعال',
    editColumn: 'ویرایش',
    deleteColumn: 'حذف',
    deleteUsedTooltip: 'دعوت‌نامه‌ی استفاده‌شده قابل حذف نیست',
    deleteConfirmTitle: 'حذف این دعوت‌نامه؟',
    deleteConfirmDescription: 'این عملیات قابل بازگشت نیست.',
    issuedFor: 'دعوت‌نامه برای {{recipient}} صادر شد',
    personalLink: 'لینک شخصی: ',
    recipientNote: 'گیرنده با وارد کردن شماره‌ی خود ({{phone}}) می‌تواند دعوت‌نامه را ببیند. حرکت قطار: {{date}} ساعت ۱۱:۰۰',
    createModalTitle: 'ایجاد دعوت‌نامه جدید',
    firstNameLabel: 'نام',
    firstNameRequired: 'نام الزامی است',
    firstNamePlaceholder: 'مثال: هری',
    lastNameLabel: 'نام خانوادگی',
    lastNameRequired: 'نام خانوادگی الزامی است',
    lastNamePlaceholder: 'مثال: پاتر',
    phoneLabel: 'شماره تماس (اختیاری — اگر خالی بماند، اولین کسی که با این لینک OTP بگیرد مالک دائمی آن می‌شود)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'آدرس - خط ۱',
    addressLine1Placeholder: 'مثال: خیابان دیاگون، پلاک ۹۳',
    addressLine2Label: 'آدرس - خط ۲',
    addressLine2Placeholder: 'مثال: محله‌ی جادوگران، لندن',
    addressLine3Label: 'آدرس - خط ۳',
    addressLine3Placeholder: 'مثال: بریتانیا',
    trainScheduleLabel: 'زمان حرکت قطار',
    trainScheduleExtra: 'اگر خالی بماند، خودکار زودترین قطار فعال و دارای جا از پنل ادمین انتخاب می‌شود.',
    trainSchedulePlaceholder: 'انتخاب از زمان‌های تعریف‌شده (یا خالی برای انتخاب خودکار)',
    scheduleFull: 'پر شده',
    scheduleRemaining: '{{remaining}} جای خالی از {{capacity}}',
    codeNeverExpires: 'این کد دعوت هرگز منقضی نمی‌شود.',
    createAndSend: 'ایجاد و ارسال',
    reassignModalTitle: 'تغییر زمان حرکت قطار این دعوت‌نامه',
    reassignUpdated: 'زمان حرکت به‌روز شد',
    reassignError: 'خطا در به‌روزرسانی زمان حرکت',
    reassignPlaceholder: 'انتخاب زمان حرکت',
    editModalTitle: 'ویرایش دعوت‌نامه',
    platformLabel: 'سکو',
    claimedWarning: 'این دعوت‌نامه قبلاً توسط گیرنده تایید شده — تغییر شماره تماس به مدیر اطلاع داده می‌شود.',
  },
  en: {
    title: 'Invitation Management',
    newInvitation: 'New Invitation',
    loadError: 'Failed to load invitations',
    createdNoPhone: 'Invitation created — send the link manually',
    createdSmsSent: 'Invitation created and SMS sent!',
    createdSmsFailed: 'Invitation created but SMS sending failed',
    createError: 'Failed to create invitation',
    resendSmsError: 'Failed to resend SMS',
    linkCopied: 'Invitation link copied',
    editSuccess: 'Invitation updated',
    editError: 'Failed to update invitation',
    toggleError: 'Failed to change invitation status',
    deleteSuccess: 'Invitation deleted',
    deleteError: 'Failed to delete invitation',
    nameColumn: 'Name',
    phoneColumn: 'Phone Number',
    codeColumn: 'Invitation Code',
    ticketCodeColumn: 'Ticket Code',
    entrySourceColumn: 'Entry Source',
    entrySourceDirect: 'Direct Invitation',
    entrySourceWaitlist: 'From Waitlist',
    trainDepartureColumn: 'Train Departure',
    setTime: 'Set Time',
    linkColumn: 'Link',
    copyLink: 'Copy Link',
    statusColumn: 'Status',
    statusUsed: '✅ Used',
    statusWaiting: '⏳ Waiting',
    viewColumn: 'Link Views',
    notOpened: 'Not Opened',
    viewedTimes: '{{first}} ({{count}} times)',
    firstViewedTooltip: 'First viewed: {{first}}',
    lastViewedSuffix: ' — Last viewed: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Sent',
    smsPending: '⏳ Pending',
    smsFailed: '❌ Failed',
    resend: 'Resend',
    activeColumn: 'Active',
    editColumn: 'Edit',
    deleteColumn: 'Delete',
    deleteUsedTooltip: 'A used invitation cannot be deleted',
    deleteConfirmTitle: 'Delete this invitation?',
    deleteConfirmDescription: 'This action cannot be undone.',
    issuedFor: 'Invitation issued for {{recipient}}',
    personalLink: 'Personal link: ',
    recipientNote: 'The recipient can view the invitation by entering their phone number ({{phone}}). Train departure: {{date}} at 11:00.',
    createModalTitle: 'Create New Invitation',
    firstNameLabel: 'First Name',
    firstNameRequired: 'First name is required',
    firstNamePlaceholder: 'e.g. Harry',
    lastNameLabel: 'Last Name',
    lastNameRequired: 'Last name is required',
    lastNamePlaceholder: 'e.g. Potter',
    phoneLabel: 'Phone number (optional — if left blank, the first person to request an OTP with this link becomes its permanent owner)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Address - Line 1',
    addressLine1Placeholder: 'e.g. Diagon Alley, No. 93',
    addressLine2Label: 'Address - Line 2',
    addressLine2Placeholder: 'e.g. Wizarding Quarter, London',
    addressLine3Label: 'Address - Line 3',
    addressLine3Placeholder: 'e.g. Britain',
    trainScheduleLabel: 'Train Departure Time',
    trainScheduleExtra: 'If left blank, the earliest active schedule with available capacity is automatically selected from the admin panel.',
    trainSchedulePlaceholder: 'Select from defined schedules (or leave blank for automatic selection)',
    scheduleFull: 'Full',
    scheduleRemaining: '{{remaining}} of {{capacity}} seats available',
    codeNeverExpires: 'This invitation code never expires.',
    createAndSend: 'Create and Send',
    reassignModalTitle: 'Change train departure time for this invitation',
    reassignUpdated: 'Departure time updated',
    reassignError: 'Failed to update departure time',
    reassignPlaceholder: 'Select departure time',
    editModalTitle: 'Edit Invitation',
    platformLabel: 'Platform',
    claimedWarning: 'This invitation has already been confirmed by the recipient — the admin will be notified of any phone number change.',
  },
  de: {
    title: 'Einladungsverwaltung',
    newInvitation: 'Neue Einladung',
    loadError: 'Einladungen konnten nicht geladen werden',
    createdNoPhone: 'Einladung erstellt — senden Sie den Link manuell',
    createdSmsSent: 'Einladung erstellt und SMS gesendet!',
    createdSmsFailed: 'Einladung erstellt, aber SMS-Versand fehlgeschlagen',
    createError: 'Einladung konnte nicht erstellt werden',
    resendSmsError: 'SMS konnte nicht erneut gesendet werden',
    linkCopied: 'Einladungslink kopiert',
    editSuccess: 'Einladung aktualisiert',
    editError: 'Einladung konnte nicht aktualisiert werden',
    toggleError: 'Status der Einladung konnte nicht geändert werden',
    deleteSuccess: 'Einladung gelöscht',
    deleteError: 'Einladung konnte nicht gelöscht werden',
    nameColumn: 'Name',
    phoneColumn: 'Telefonnummer',
    codeColumn: 'Einladungscode',
    ticketCodeColumn: 'Ticketcode',
    entrySourceColumn: 'Eintrittsquelle',
    entrySourceDirect: 'Direkte Einladung',
    entrySourceWaitlist: 'Von der Warteliste',
    trainDepartureColumn: 'Zugabfahrt',
    setTime: 'Zeit festlegen',
    linkColumn: 'Link',
    copyLink: 'Link kopieren',
    statusColumn: 'Status',
    statusUsed: '✅ Verwendet',
    statusWaiting: '⏳ Wartend',
    viewColumn: 'Link-Aufrufe',
    notOpened: 'Nicht geöffnet',
    viewedTimes: '{{first}} ({{count}} Mal)',
    firstViewedTooltip: 'Zuerst angesehen: {{first}}',
    lastViewedSuffix: ' — Zuletzt angesehen: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Gesendet',
    smsPending: '⏳ Ausstehend',
    smsFailed: '❌ Fehlgeschlagen',
    resend: 'Erneut senden',
    activeColumn: 'Aktiv',
    editColumn: 'Bearbeiten',
    deleteColumn: 'Löschen',
    deleteUsedTooltip: 'Eine verwendete Einladung kann nicht gelöscht werden',
    deleteConfirmTitle: 'Diese Einladung löschen?',
    deleteConfirmDescription: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    issuedFor: 'Einladung ausgestellt für {{recipient}}',
    personalLink: 'Persönlicher Link: ',
    recipientNote: 'Der Empfänger kann die Einladung einsehen, indem er seine Telefonnummer ({{phone}}) eingibt. Zugabfahrt: {{date}} um 11:00 Uhr.',
    createModalTitle: 'Neue Einladung erstellen',
    firstNameLabel: 'Vorname',
    firstNameRequired: 'Vorname ist erforderlich',
    firstNamePlaceholder: 'z. B. Harry',
    lastNameLabel: 'Nachname',
    lastNameRequired: 'Nachname ist erforderlich',
    lastNamePlaceholder: 'z. B. Potter',
    phoneLabel: 'Telefonnummer (optional — bleibt sie leer, wird die erste Person, die mit diesem Link einen OTP anfordert, dauerhafter Besitzer)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Adresse - Zeile 1',
    addressLine1Placeholder: 'z. B. Winkelgasse, Nr. 93',
    addressLine2Label: 'Adresse - Zeile 2',
    addressLine2Placeholder: 'z. B. Zaubererviertel, London',
    addressLine3Label: 'Adresse - Zeile 3',
    addressLine3Placeholder: 'z. B. Großbritannien',
    trainScheduleLabel: 'Zugabfahrtszeit',
    trainScheduleExtra: 'Wenn leer gelassen, wird automatisch der früheste aktive Fahrplan mit verfügbarer Kapazität aus dem Admin-Panel ausgewählt.',
    trainSchedulePlaceholder: 'Aus definierten Zeiten wählen (oder leer lassen für automatische Auswahl)',
    scheduleFull: 'Voll',
    scheduleRemaining: '{{remaining}} von {{capacity}} Plätzen verfügbar',
    codeNeverExpires: 'Dieser Einladungscode läuft niemals ab.',
    createAndSend: 'Erstellen und senden',
    reassignModalTitle: 'Zugabfahrtszeit für diese Einladung ändern',
    reassignUpdated: 'Abfahrtszeit aktualisiert',
    reassignError: 'Abfahrtszeit konnte nicht aktualisiert werden',
    reassignPlaceholder: 'Abfahrtszeit wählen',
    editModalTitle: 'Einladung bearbeiten',
    platformLabel: 'Gleis',
    claimedWarning: 'Diese Einladung wurde bereits vom Empfänger bestätigt — der Administrator wird bei einer Änderung der Telefonnummer benachrichtigt.',
  },
  es: {
    title: 'Gestión de invitaciones',
    newInvitation: 'Nueva invitación',
    loadError: 'Error al cargar las invitaciones',
    createdNoPhone: 'Invitación creada — envíe el enlace manualmente',
    createdSmsSent: '¡Invitación creada y SMS enviado!',
    createdSmsFailed: 'Invitación creada, pero el envío del SMS falló',
    createError: 'Error al crear la invitación',
    resendSmsError: 'Error al reenviar el SMS',
    linkCopied: 'Enlace de invitación copiado',
    editSuccess: 'Invitación actualizada',
    editError: 'Error al actualizar la invitación',
    toggleError: 'Error al cambiar el estado de la invitación',
    deleteSuccess: 'Invitación eliminada',
    deleteError: 'Error al eliminar la invitación',
    nameColumn: 'Nombre',
    phoneColumn: 'Número de teléfono',
    codeColumn: 'Código de invitación',
    ticketCodeColumn: 'Código de billete',
    entrySourceColumn: 'Origen de entrada',
    entrySourceDirect: 'Invitación directa',
    entrySourceWaitlist: 'De la lista de espera',
    trainDepartureColumn: 'Salida del tren',
    setTime: 'Fijar hora',
    linkColumn: 'Enlace',
    copyLink: 'Copiar enlace',
    statusColumn: 'Estado',
    statusUsed: '✅ Usada',
    statusWaiting: '⏳ Pendiente',
    viewColumn: 'Vistas del enlace',
    notOpened: 'No abierto',
    viewedTimes: '{{first}} ({{count}} veces)',
    firstViewedTooltip: 'Primera visualización: {{first}}',
    lastViewedSuffix: ' — Última visualización: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Enviado',
    smsPending: '⏳ Pendiente',
    smsFailed: '❌ Fallido',
    resend: 'Reenviar',
    activeColumn: 'Activa',
    editColumn: 'Editar',
    deleteColumn: 'Eliminar',
    deleteUsedTooltip: 'No se puede eliminar una invitación ya utilizada',
    deleteConfirmTitle: '¿Eliminar esta invitación?',
    deleteConfirmDescription: 'Esta acción no se puede deshacer.',
    issuedFor: 'Invitación emitida para {{recipient}}',
    personalLink: 'Enlace personal: ',
    recipientNote: 'El destinatario podrá ver la invitación introduciendo su número ({{phone}}). Salida del tren: {{date}} a las 11:00.',
    createModalTitle: 'Crear nueva invitación',
    firstNameLabel: 'Nombre',
    firstNameRequired: 'El nombre es obligatorio',
    firstNamePlaceholder: 'p. ej. Harry',
    lastNameLabel: 'Apellido',
    lastNameRequired: 'El apellido es obligatorio',
    lastNamePlaceholder: 'p. ej. Potter',
    phoneLabel: 'Número de teléfono (opcional — si se deja en blanco, la primera persona que solicite un OTP con este enlace se convierte en su propietario permanente)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Dirección - Línea 1',
    addressLine1Placeholder: 'p. ej. Callejón Diagon, N.º 93',
    addressLine2Label: 'Dirección - Línea 2',
    addressLine2Placeholder: 'p. ej. Barrio mágico, Londres',
    addressLine3Label: 'Dirección - Línea 3',
    addressLine3Placeholder: 'p. ej. Reino Unido',
    trainScheduleLabel: 'Hora de salida del tren',
    trainScheduleExtra: 'Si se deja en blanco, se seleccionará automáticamente el horario activo más próximo con capacidad disponible desde el panel de administración.',
    trainSchedulePlaceholder: 'Seleccionar de los horarios definidos (o dejar en blanco para selección automática)',
    scheduleFull: 'Completo',
    scheduleRemaining: '{{remaining}} de {{capacity}} plazas disponibles',
    codeNeverExpires: 'Este código de invitación nunca caduca.',
    createAndSend: 'Crear y enviar',
    reassignModalTitle: 'Cambiar la hora de salida del tren de esta invitación',
    reassignUpdated: 'Hora de salida actualizada',
    reassignError: 'Error al actualizar la hora de salida',
    reassignPlaceholder: 'Seleccionar hora de salida',
    editModalTitle: 'Editar invitación',
    platformLabel: 'Andén',
    claimedWarning: 'Esta invitación ya fue confirmada por el destinatario — se notificará al administrador de cualquier cambio de número de teléfono.',
  },
  fr: {
    title: 'Gestion des invitations',
    newInvitation: 'Nouvelle invitation',
    loadError: 'Échec du chargement des invitations',
    createdNoPhone: 'Invitation créée — envoyez le lien manuellement',
    createdSmsSent: 'Invitation créée et SMS envoyé !',
    createdSmsFailed: "Invitation créée mais l'envoi du SMS a échoué",
    createError: "Échec de la création de l'invitation",
    resendSmsError: 'Échec du renvoi du SMS',
    linkCopied: "Lien d'invitation copié",
    editSuccess: 'Invitation mise à jour',
    editError: "Échec de la mise à jour de l'invitation",
    toggleError: "Échec du changement de statut de l'invitation",
    deleteSuccess: 'Invitation supprimée',
    deleteError: "Échec de la suppression de l'invitation",
    nameColumn: 'Nom',
    phoneColumn: 'Numéro de téléphone',
    codeColumn: "Code d'invitation",
    ticketCodeColumn: 'Code du billet',
    entrySourceColumn: "Source d'entrée",
    entrySourceDirect: 'Invitation directe',
    entrySourceWaitlist: "Depuis la liste d'attente",
    trainDepartureColumn: 'Départ du train',
    setTime: "Définir l'heure",
    linkColumn: 'Lien',
    copyLink: 'Copier le lien',
    statusColumn: 'Statut',
    statusUsed: '✅ Utilisée',
    statusWaiting: '⏳ En attente',
    viewColumn: 'Vues du lien',
    notOpened: 'Non ouvert',
    viewedTimes: '{{first}} ({{count}} fois)',
    firstViewedTooltip: 'Première visualisation : {{first}}',
    lastViewedSuffix: ' — Dernière visualisation : {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Envoyé',
    smsPending: '⏳ En attente',
    smsFailed: '❌ Échoué',
    resend: 'Renvoyer',
    activeColumn: 'Active',
    editColumn: 'Modifier',
    deleteColumn: 'Supprimer',
    deleteUsedTooltip: 'Une invitation utilisée ne peut pas être supprimée',
    deleteConfirmTitle: 'Supprimer cette invitation ?',
    deleteConfirmDescription: 'Cette action est irréversible.',
    issuedFor: 'Invitation émise pour {{recipient}}',
    personalLink: 'Lien personnel : ',
    recipientNote: 'Le destinataire peut consulter l\'invitation en saisissant son numéro ({{phone}}). Départ du train : {{date}} à 11h00.',
    createModalTitle: 'Créer une nouvelle invitation',
    firstNameLabel: 'Prénom',
    firstNameRequired: 'Le prénom est obligatoire',
    firstNamePlaceholder: 'ex. Harry',
    lastNameLabel: 'Nom de famille',
    lastNameRequired: 'Le nom de famille est obligatoire',
    lastNamePlaceholder: 'ex. Potter',
    phoneLabel: 'Numéro de téléphone (facultatif — s\'il est laissé vide, la première personne à demander un OTP avec ce lien en devient le propriétaire permanent)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Adresse - Ligne 1',
    addressLine1Placeholder: 'ex. Allée des Embrumes, n° 93',
    addressLine2Label: 'Adresse - Ligne 2',
    addressLine2Placeholder: 'ex. Quartier des sorciers, Londres',
    addressLine3Label: 'Adresse - Ligne 3',
    addressLine3Placeholder: 'ex. Royaume-Uni',
    trainScheduleLabel: 'Heure de départ du train',
    trainScheduleExtra: "Si laissé vide, l'horaire actif le plus proche disposant de places est sélectionné automatiquement depuis le panneau d'administration.",
    trainSchedulePlaceholder: 'Sélectionner parmi les horaires définis (ou laisser vide pour une sélection automatique)',
    scheduleFull: 'Complet',
    scheduleRemaining: '{{remaining}} places disponibles sur {{capacity}}',
    codeNeverExpires: "Ce code d'invitation n'expire jamais.",
    createAndSend: 'Créer et envoyer',
    reassignModalTitle: "Changer l'heure de départ du train de cette invitation",
    reassignUpdated: 'Heure de départ mise à jour',
    reassignError: "Échec de la mise à jour de l'heure de départ",
    reassignPlaceholder: "Sélectionner l'heure de départ",
    editModalTitle: "Modifier l'invitation",
    platformLabel: 'Quai',
    claimedWarning: "Cette invitation a déjà été confirmée par le destinataire — l'administrateur sera informé de tout changement de numéro de téléphone.",
  },
  it: {
    title: 'Gestione degli inviti',
    newInvitation: 'Nuovo invito',
    loadError: 'Impossibile caricare gli inviti',
    createdNoPhone: 'Invito creato — invia il link manualmente',
    createdSmsSent: 'Invito creato e SMS inviato!',
    createdSmsFailed: "Invito creato ma l'invio dell'SMS non è riuscito",
    createError: "Impossibile creare l'invito",
    resendSmsError: "Impossibile reinviare l'SMS",
    linkCopied: 'Link di invito copiato',
    editSuccess: 'Invito aggiornato',
    editError: "Impossibile aggiornare l'invito",
    toggleError: "Impossibile modificare lo stato dell'invito",
    deleteSuccess: 'Invito eliminato',
    deleteError: "Impossibile eliminare l'invito",
    nameColumn: 'Nome',
    phoneColumn: 'Numero di telefono',
    codeColumn: 'Codice invito',
    ticketCodeColumn: 'Codice biglietto',
    entrySourceColumn: "Origine dell'ingresso",
    entrySourceDirect: 'Invito diretto',
    entrySourceWaitlist: "Dalla lista d'attesa",
    trainDepartureColumn: 'Partenza del treno',
    setTime: 'Imposta orario',
    linkColumn: 'Link',
    copyLink: 'Copia link',
    statusColumn: 'Stato',
    statusUsed: '✅ Utilizzato',
    statusWaiting: '⏳ In attesa',
    viewColumn: 'Visualizzazioni link',
    notOpened: 'Non aperto',
    viewedTimes: '{{first}} ({{count}} volte)',
    firstViewedTooltip: 'Prima visualizzazione: {{first}}',
    lastViewedSuffix: ' — Ultima visualizzazione: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Inviato',
    smsPending: '⏳ In sospeso',
    smsFailed: '❌ Non riuscito',
    resend: 'Invia di nuovo',
    activeColumn: 'Attivo',
    editColumn: 'Modifica',
    deleteColumn: 'Elimina',
    deleteUsedTooltip: 'Un invito già utilizzato non può essere eliminato',
    deleteConfirmTitle: 'Eliminare questo invito?',
    deleteConfirmDescription: "Questa azione non può essere annullata.",
    issuedFor: 'Invito emesso per {{recipient}}',
    personalLink: 'Link personale: ',
    recipientNote: 'Il destinatario può visualizzare l\'invito inserendo il proprio numero ({{phone}}). Partenza del treno: {{date}} alle 11:00.',
    createModalTitle: 'Crea nuovo invito',
    firstNameLabel: 'Nome',
    firstNameRequired: 'Il nome è obbligatorio',
    firstNamePlaceholder: 'es. Harry',
    lastNameLabel: 'Cognome',
    lastNameRequired: 'Il cognome è obbligatorio',
    lastNamePlaceholder: 'es. Potter',
    phoneLabel: 'Numero di telefono (facoltativo — se lasciato vuoto, la prima persona che richiede un OTP con questo link ne diventa il proprietario permanente)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Indirizzo - Riga 1',
    addressLine1Placeholder: 'es. Vicolo Diagon, N. 93',
    addressLine2Label: 'Indirizzo - Riga 2',
    addressLine2Placeholder: 'es. Quartiere dei maghi, Londra',
    addressLine3Label: 'Indirizzo - Riga 3',
    addressLine3Placeholder: 'es. Regno Unito',
    trainScheduleLabel: 'Orario di partenza del treno',
    trainScheduleExtra: "Se lasciato vuoto, viene selezionato automaticamente l'orario attivo più vicino con posti disponibili dal pannello di amministrazione.",
    trainSchedulePlaceholder: 'Seleziona tra gli orari definiti (o lascia vuoto per la selezione automatica)',
    scheduleFull: 'Completo',
    scheduleRemaining: '{{remaining}} posti disponibili su {{capacity}}',
    codeNeverExpires: 'Questo codice invito non scade mai.',
    createAndSend: 'Crea e invia',
    reassignModalTitle: "Cambia l'orario di partenza del treno per questo invito",
    reassignUpdated: 'Orario di partenza aggiornato',
    reassignError: "Impossibile aggiornare l'orario di partenza",
    reassignPlaceholder: 'Seleziona orario di partenza',
    editModalTitle: 'Modifica invito',
    platformLabel: 'Binario',
    claimedWarning: "Questo invito è già stato confermato dal destinatario — l'amministratore sarà informato di eventuali cambi di numero di telefono.",
  },
  ja: {
    title: '招待管理',
    newInvitation: '新しい招待',
    loadError: '招待の読み込みに失敗しました',
    createdNoPhone: '招待を作成しました — リンクを手動で送信してください',
    createdSmsSent: '招待を作成し、SMSを送信しました!',
    createdSmsFailed: '招待は作成されましたが、SMSの送信に失敗しました',
    createError: '招待の作成に失敗しました',
    resendSmsError: 'SMSの再送信に失敗しました',
    linkCopied: '招待リンクをコピーしました',
    editSuccess: '招待を更新しました',
    editError: '招待の更新に失敗しました',
    toggleError: '招待の状態変更に失敗しました',
    deleteSuccess: '招待を削除しました',
    deleteError: '招待の削除に失敗しました',
    nameColumn: '名前',
    phoneColumn: '電話番号',
    codeColumn: '招待コード',
    ticketCodeColumn: 'チケットコード',
    entrySourceColumn: '登録経路',
    entrySourceDirect: '直接招待',
    entrySourceWaitlist: 'ウェイトリストから',
    trainDepartureColumn: '列車の出発',
    setTime: '時間を設定',
    linkColumn: 'リンク',
    copyLink: 'リンクをコピー',
    statusColumn: 'ステータス',
    statusUsed: '✅ 使用済み',
    statusWaiting: '⏳ 待機中',
    viewColumn: 'リンクの閲覧',
    notOpened: '未開封',
    viewedTimes: '{{first}} ({{count}}回)',
    firstViewedTooltip: '初回閲覧: {{first}}',
    lastViewedSuffix: ' — 最終閲覧: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ 送信済み',
    smsPending: '⏳ 保留中',
    smsFailed: '❌ 失敗',
    resend: '再送信',
    activeColumn: '有効',
    editColumn: '編集',
    deleteColumn: '削除',
    deleteUsedTooltip: '使用済みの招待は削除できません',
    deleteConfirmTitle: 'この招待を削除しますか?',
    deleteConfirmDescription: 'この操作は元に戻せません。',
    issuedFor: '{{recipient}}宛に招待を発行しました',
    personalLink: '個人リンク: ',
    recipientNote: '受信者は自分の電話番号({{phone}})を入力することで招待を確認できます。列車の出発: {{date}} 11:00。',
    createModalTitle: '新しい招待を作成',
    firstNameLabel: '名',
    firstNameRequired: '名は必須です',
    firstNamePlaceholder: '例: ハリー',
    lastNameLabel: '姓',
    lastNameRequired: '姓は必須です',
    lastNamePlaceholder: '例: ポッター',
    phoneLabel: '電話番号(任意 — 空欄の場合、このリンクで最初にOTPを取得した人が恒久的な所有者になります)',
    phonePlaceholder: '09123456789',
    addressLine1Label: '住所 - 1行目',
    addressLine1Placeholder: '例: ダイアゴン横丁 93番地',
    addressLine2Label: '住所 - 2行目',
    addressLine2Placeholder: '例: 魔法使い地区、ロンドン',
    addressLine3Label: '住所 - 3行目',
    addressLine3Placeholder: '例: イギリス',
    trainScheduleLabel: '列車の出発時刻',
    trainScheduleExtra: '空欄の場合、管理パネルから利用可能な最も早い有効なスケジュールが自動的に選択されます。',
    trainSchedulePlaceholder: '定義済みの時刻から選択(または自動選択の場合は空欄のまま)',
    scheduleFull: '満席',
    scheduleRemaining: '{{capacity}}席中{{remaining}}席空きあり',
    codeNeverExpires: 'この招待コードは無期限です。',
    createAndSend: '作成して送信',
    reassignModalTitle: 'この招待の列車出発時刻を変更',
    reassignUpdated: '出発時刻を更新しました',
    reassignError: '出発時刻の更新に失敗しました',
    reassignPlaceholder: '出発時刻を選択',
    editModalTitle: '招待を編集',
    platformLabel: 'プラットフォーム',
    claimedWarning: 'この招待はすでに受信者によって確認されています — 電話番号の変更は管理者に通知されます。',
  },
  ko: {
    title: '초대 관리',
    newInvitation: '새 초대',
    loadError: '초대 목록을 불러오지 못했습니다',
    createdNoPhone: '초대가 생성되었습니다 — 링크를 직접 전송하세요',
    createdSmsSent: '초대가 생성되고 SMS가 전송되었습니다!',
    createdSmsFailed: '초대는 생성되었지만 SMS 전송에 실패했습니다',
    createError: '초대 생성에 실패했습니다',
    resendSmsError: 'SMS 재전송에 실패했습니다',
    linkCopied: '초대 링크가 복사되었습니다',
    editSuccess: '초대가 수정되었습니다',
    editError: '초대 수정에 실패했습니다',
    toggleError: '초대 상태 변경에 실패했습니다',
    deleteSuccess: '초대가 삭제되었습니다',
    deleteError: '초대 삭제에 실패했습니다',
    nameColumn: '이름',
    phoneColumn: '전화번호',
    codeColumn: '초대 코드',
    ticketCodeColumn: '티켓 코드',
    entrySourceColumn: '유입 경로',
    entrySourceDirect: '직접 초대',
    entrySourceWaitlist: '대기자 명단에서',
    trainDepartureColumn: '기차 출발',
    setTime: '시간 설정',
    linkColumn: '링크',
    copyLink: '링크 복사',
    statusColumn: '상태',
    statusUsed: '✅ 사용됨',
    statusWaiting: '⏳ 대기 중',
    viewColumn: '링크 조회',
    notOpened: '열지 않음',
    viewedTimes: '{{first}} ({{count}}회)',
    firstViewedTooltip: '최초 조회: {{first}}',
    lastViewedSuffix: ' — 마지막 조회: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ 전송됨',
    smsPending: '⏳ 대기 중',
    smsFailed: '❌ 실패',
    resend: '재전송',
    activeColumn: '활성',
    editColumn: '수정',
    deleteColumn: '삭제',
    deleteUsedTooltip: '이미 사용된 초대는 삭제할 수 없습니다',
    deleteConfirmTitle: '이 초대를 삭제하시겠습니까?',
    deleteConfirmDescription: '이 작업은 되돌릴 수 없습니다.',
    issuedFor: '{{recipient}}님에게 초대가 발급되었습니다',
    personalLink: '개인 링크: ',
    recipientNote: '수신자는 자신의 전화번호({{phone}})를 입력하여 초대를 확인할 수 있습니다. 기차 출발: {{date}} 11:00.',
    createModalTitle: '새 초대 생성',
    firstNameLabel: '이름',
    firstNameRequired: '이름은 필수입니다',
    firstNamePlaceholder: '예: 해리',
    lastNameLabel: '성',
    lastNameRequired: '성은 필수입니다',
    lastNamePlaceholder: '예: 포터',
    phoneLabel: '전화번호(선택 사항 — 비워두면 이 링크로 OTP를 처음 요청하는 사람이 영구 소유자가 됩니다)',
    phonePlaceholder: '09123456789',
    addressLine1Label: '주소 - 1행',
    addressLine1Placeholder: '예: 다이애건 앨리 93번지',
    addressLine2Label: '주소 - 2행',
    addressLine2Placeholder: '예: 마법사 구역, 런던',
    addressLine3Label: '주소 - 3행',
    addressLine3Placeholder: '예: 영국',
    trainScheduleLabel: '기차 출발 시간',
    trainScheduleExtra: '비워두면 관리 패널에서 사용 가능한 좌석이 있는 가장 빠른 활성 일정이 자동으로 선택됩니다.',
    trainSchedulePlaceholder: '정의된 시간 중에서 선택(또는 자동 선택을 위해 비워두기)',
    scheduleFull: '만석',
    scheduleRemaining: '{{capacity}}석 중 {{remaining}}석 남음',
    codeNeverExpires: '이 초대 코드는 만료되지 않습니다.',
    createAndSend: '생성 및 전송',
    reassignModalTitle: '이 초대의 기차 출발 시간 변경',
    reassignUpdated: '출발 시간이 업데이트되었습니다',
    reassignError: '출발 시간 업데이트에 실패했습니다',
    reassignPlaceholder: '출발 시간 선택',
    editModalTitle: '초대 수정',
    platformLabel: '플랫폼',
    claimedWarning: '이 초대는 이미 수신자가 확인했습니다 — 전화번호 변경 시 관리자에게 통보됩니다.',
  },
  pt: {
    title: 'Gestão de convites',
    newInvitation: 'Novo convite',
    loadError: 'Falha ao carregar os convites',
    createdNoPhone: 'Convite criado — envie o link manualmente',
    createdSmsSent: 'Convite criado e SMS enviado!',
    createdSmsFailed: 'Convite criado, mas o envio do SMS falhou',
    createError: 'Falha ao criar o convite',
    resendSmsError: 'Falha ao reenviar o SMS',
    linkCopied: 'Link do convite copiado',
    editSuccess: 'Convite atualizado',
    editError: 'Falha ao atualizar o convite',
    toggleError: 'Falha ao alterar o status do convite',
    deleteSuccess: 'Convite excluído',
    deleteError: 'Falha ao excluir o convite',
    nameColumn: 'Nome',
    phoneColumn: 'Número de telefone',
    codeColumn: 'Código do convite',
    ticketCodeColumn: 'Código do bilhete',
    entrySourceColumn: 'Origem de entrada',
    entrySourceDirect: 'Convite direto',
    entrySourceWaitlist: 'Da lista de espera',
    trainDepartureColumn: 'Partida do trem',
    setTime: 'Definir horário',
    linkColumn: 'Link',
    copyLink: 'Copiar link',
    statusColumn: 'Status',
    statusUsed: '✅ Utilizado',
    statusWaiting: '⏳ Aguardando',
    viewColumn: 'Visualizações do link',
    notOpened: 'Não aberto',
    viewedTimes: '{{first}} ({{count}} vezes)',
    firstViewedTooltip: 'Primeira visualização: {{first}}',
    lastViewedSuffix: ' — Última visualização: {{last}}',
    smsColumn: 'SMS',
    smsSent: '✅ Enviado',
    smsPending: '⏳ Pendente',
    smsFailed: '❌ Falhou',
    resend: 'Reenviar',
    activeColumn: 'Ativo',
    editColumn: 'Editar',
    deleteColumn: 'Excluir',
    deleteUsedTooltip: 'Um convite já utilizado não pode ser excluído',
    deleteConfirmTitle: 'Excluir este convite?',
    deleteConfirmDescription: 'Esta ação não pode ser desfeita.',
    issuedFor: 'Convite emitido para {{recipient}}',
    personalLink: 'Link pessoal: ',
    recipientNote: 'O destinatário pode ver o convite inserindo seu número ({{phone}}). Partida do trem: {{date}} às 11:00.',
    createModalTitle: 'Criar novo convite',
    firstNameLabel: 'Nome',
    firstNameRequired: 'O nome é obrigatório',
    firstNamePlaceholder: 'ex.: Harry',
    lastNameLabel: 'Sobrenome',
    lastNameRequired: 'O sobrenome é obrigatório',
    lastNamePlaceholder: 'ex.: Potter',
    phoneLabel: 'Número de telefone (opcional — se deixado em branco, a primeira pessoa a solicitar um OTP com este link se torna o proprietário permanente)',
    phonePlaceholder: '09123456789',
    addressLine1Label: 'Endereço - Linha 1',
    addressLine1Placeholder: 'ex.: Beco Diagonal, N.º 93',
    addressLine2Label: 'Endereço - Linha 2',
    addressLine2Placeholder: 'ex.: Bairro dos bruxos, Londres',
    addressLine3Label: 'Endereço - Linha 3',
    addressLine3Placeholder: 'ex.: Reino Unido',
    trainScheduleLabel: 'Horário de partida do trem',
    trainScheduleExtra: 'Se deixado em branco, o horário ativo mais próximo com vagas disponíveis será selecionado automaticamente no painel de administração.',
    trainSchedulePlaceholder: 'Selecionar entre os horários definidos (ou deixar em branco para seleção automática)',
    scheduleFull: 'Lotado',
    scheduleRemaining: '{{remaining}} de {{capacity}} vagas disponíveis',
    codeNeverExpires: 'Este código de convite nunca expira.',
    createAndSend: 'Criar e enviar',
    reassignModalTitle: 'Alterar o horário de partida do trem deste convite',
    reassignUpdated: 'Horário de partida atualizado',
    reassignError: 'Falha ao atualizar o horário de partida',
    reassignPlaceholder: 'Selecionar horário de partida',
    editModalTitle: 'Editar convite',
    platformLabel: 'Plataforma',
    claimedWarning: 'Este convite já foi confirmado pelo destinatário — o administrador será notificado sobre qualquer alteração no número de telefone.',
  },
};
